module.exports = __webpack_public_path__ + "img/parner2.29270a67.png";